import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Sneaker Bazaar" link="https://satyam-52.github.io/sneaker-bazaar" bg="linear-gradient(to right,#D4145A 0%,#FBB03B 100%)" mdxType="ProjectCard">
When a sneaker head learns web development, you get this..
    </ProjectCard>
    <ProjectCard title="Lunchbreak Bank" link="https://lunchbreak-bank.web.app/" bg="linear-gradient(to right,#662D8C 0%,#ED1E79 100%)" mdxType="ProjectCard">
I used ReactJS for the front-end and firebase for real-time database and deployment. 
    </ProjectCard>
    <ProjectCard title="Spotify Clone" link="https://satyam-52.github.io/spotify-ui-clone/" bg="linear-gradient(to right,#009245 0%,#FCEE21 100%)" mdxType="ProjectCard">
I really loved the UI of spotify, so made it my own..
    </ProjectCard>
    <ProjectCard title="Amazon Clone" link="https://satyam-52.github.io/amazon-clone/" bg="linear-gradient(to right,#D585FF 0%,#00FFEE 100%)" mdxType="ProjectCard">
Fully functional Amazon clone. Backend is handled using firebase..
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      